import { cx } from "@emotion/css";
import type * as React from "react";
import * as styles from "./LegacyDataTableStyles";
interface LegacyDataTableRowHeaderColumnProps {
    className?: string;
    inSidebar?: boolean;
    children?: React.ReactNode;
}
export function LegacyDataTableRowHeaderColumn({ className, inSidebar, children, ...otherProps }: LegacyDataTableRowHeaderColumnProps): React.ReactElement {
    return (<th className={cx(styles.dataTableRowHeaderColumn, inSidebar ? styles.dataTableRowHeaderColumnInSidebar : null, className)} {...otherProps}>
            {children}
        </th>);
}
